var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal overflow-auto",
      attrs: { "select-cy": "create-user" }
    },
    [
      _c(
        "div",
        { staticClass: "card inner" },
        [
          _c("div", { staticClass: "header" }, [
            _vm._m(0),
            _c(
              "div",
              {
                staticClass: "close",
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              },
              [_c("i", { staticClass: "icn icn-x sm" })]
            )
          ]),
          _c("div", { staticClass: "content" }, [
            _c(
              "form",
              {
                attrs: { id: "user-details" },
                on: {
                  submit: [
                    function($event) {
                      $event.preventDefault()
                    },
                    _vm.create
                  ]
                }
              },
              [
                _c("h3", { staticClass: "sub-title" }, [_vm._v("Details")]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.firstName,
                          expression: "item.firstName"
                        }
                      ],
                      attrs: {
                        required: "",
                        type: "text",
                        placeholder: "First name*",
                        maxlength: "127",
                        autocomplete: "nope",
                        "data-cy": "first"
                      },
                      domProps: { value: _vm.item.firstName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.item, "firstName", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.lastName,
                          expression: "item.lastName"
                        }
                      ],
                      attrs: {
                        required: "",
                        type: "text",
                        placeholder: "Last name*",
                        maxlength: "127",
                        autocomplete: "nope",
                        "data-cy": "last"
                      },
                      domProps: { value: _vm.item.lastName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.item, "lastName", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.email,
                          expression: "item.email"
                        }
                      ],
                      attrs: {
                        required: "",
                        type: "text",
                        pattern: "[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
                        title: "E.g: johndoe@example.com",
                        placeholder: "Email*",
                        maxlength: "127",
                        autocomplete: "nope",
                        "data-cy": "email"
                      },
                      domProps: { value: _vm.item.email },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.item, "email", $event.target.value)
                          },
                          function($event) {
                            return _vm.onEmailInput()
                          }
                        ]
                      }
                    })
                  ])
                ]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.password,
                          expression: "item.password"
                        }
                      ],
                      attrs: {
                        required: "",
                        type: "text",
                        placeholder: "Password*",
                        maxlength: "127",
                        minlength: "6",
                        autocomplete: "nope",
                        "data-cy": "password"
                      },
                      domProps: { value: _vm.item.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.item, "password", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "for-checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.sendResetPasswordEmail,
                            expression: "sendResetPasswordEmail"
                          }
                        ],
                        attrs: { type: "checkbox", "data-cy": "send-email" },
                        domProps: {
                          checked: Array.isArray(_vm.sendResetPasswordEmail)
                            ? _vm._i(_vm.sendResetPasswordEmail, null) > -1
                            : _vm.sendResetPasswordEmail
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.sendResetPasswordEmail,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.sendResetPasswordEmail = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.sendResetPasswordEmail = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.sendResetPasswordEmail = $$c
                            }
                          }
                        }
                      }),
                      _c("span", [
                        _vm._v("Send reset password email on create.")
                      ])
                    ])
                  ])
                ]),
                _vm.canEditSuperAdmin
                  ? _c("h3", { staticClass: "sub-title" }, [_vm._v("Access")])
                  : _vm._e(),
                _vm.canEditSuperAdmin
                  ? _c("div", { staticClass: "row mt-2" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("Toggle", {
                            ref: "toggleAdmin",
                            attrs: { label: "Is super admin", default: false }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _c("h3", { staticClass: "sub-title" }, [_vm._v("Company")]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.companyId,
                            expression: "item.companyId"
                          }
                        ],
                        attrs: { required: "" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.item,
                              "companyId",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(_vm.companies, function(c) {
                        return _c(
                          "option",
                          {
                            key: c.id,
                            domProps: {
                              value: c.id,
                              selected: c.id === _vm.item.companyId
                            }
                          },
                          [_vm._v(" " + _vm._s(c.name) + " ")]
                        )
                      }),
                      0
                    )
                  ])
                ])
              ]
            )
          ]),
          _vm.errorMessage
            ? _c("Alert", { attrs: { message: _vm.errorMessage } })
            : _vm._e(),
          _c("div", { staticClass: "footer" }, [
            _c(
              "button",
              {
                staticClass: "secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              },
              [_vm._v("Cancel")]
            ),
            _c("div", { staticClass: "flex-grow" }),
            _c(
              "button",
              {
                attrs: { type: "submit", disabled: !_vm.canSubmit },
                on: {
                  click: function($event) {
                    return _vm.create()
                  }
                }
              },
              [
                !_vm.isValidating
                  ? _c("span", [_vm._v("Create & close")])
                  : _vm._e(),
                _vm.isValidating
                  ? _c("span", { staticClass: "icon" }, [
                      _c("i", {
                        staticClass: "icn icn-refresh sm animate-reverse-spin"
                      })
                    ])
                  : _vm._e()
              ]
            ),
            _c(
              "button",
              {
                attrs: { type: "submit", disabled: !_vm.canSubmit },
                on: {
                  click: function($event) {
                    return _vm.createAndView()
                  }
                }
              },
              [
                !_vm.isValidating
                  ? _c("span", [_vm._v("Create & view")])
                  : _vm._e(),
                _vm.isValidating
                  ? _c("span", { staticClass: "icon" }, [
                      _c("i", {
                        staticClass: "icn icn-refresh sm animate-reverse-spin"
                      })
                    ])
                  : _vm._e()
              ]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("h2", [_vm._v("New User")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }